"use strict";

angular.module("customer")
.service("InventoryReportService", function($resource, appConfig, FlashBag) {
    var availableCatalogsResource = $resource(appConfig.API_SERVER + "/sales-representatives/catalog/inventory-report/", {}, {
        query: {
            method: "get",
            isArray: true
        }
    });
    var catalogResource = $resource(
        appConfig.API_SERVER + "/sales-representatives/catalog/inventory-report/:id/", {
            id: "@id",
        }, {
            query: {
                method: "GET",
                interceptor: {responseError: FlashBag.responseErrorInterceptor}
            }
        }
    );
    var productResource = $resource(
        appConfig.API_SERVER + "/sales-representatives/product/inventory-report/", {
            pdfFormat: "@pdfFormat"
        }, {
            query: {
                method: "GET",
                interceptor: {responseError: FlashBag.responseErrorInterceptor}
            }
        }
    );

    this.queryAvailableCatalogs = function() {
        return availableCatalogsResource.query();
    };

    this.queryCatalogInventory = function(catalogId) {
        return catalogResource.query({id: catalogId});
    };

    this.queryProductInventory = function() {
        return productResource.query();
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/inventory-report/inventory-report.service.js
// module id = 950
// module chunks = 0